// extracted by mini-css-extract-plugin
module.exports = {"section":"page_section__yYXnF","title":"page_title__TZ6P1 typographyHeadlineMedium","body":"page_body__F_rFz typographyBodyMedium"};